export default {
  "REQUEST-EDITED": "¡Solicitud editada correctamente!"
};
